/* eslint-disable */

import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Isotope from "isotope-layout";
// import VanillaTilt from 'vanilla-tilt';
import lottie from "lottie-web";
import Flickity from "flickity";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Toggle
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();
          HTML.classList.toggle("open-menu");
        });
      });
    }

    /** Cursor */
    const cursor = document.querySelector(".cursor");
    if (cursor) {

      if( this.isTouchDevice() ) cursor.remove();

      window.addEventListener("mousemove", (e) => {
        gsap.set(cursor, {
          autoAlpha: 1,
          x: e.clientX,
          y: e.clientY,
        });
      });

      const timerShoot = 0;
      window.addEventListener("click", () => {
        cursor.classList.add("shoot");

        setTimeout(() => {
          cursor.classList.remove("shoot");
        }, 100);
      });
    }

    this.bodymovin();
    this.anchor();
    this.contact();
    this.cloud();
    this.parallax();
    this.accordion();
    this.coverVideo();
    this.artistList();
    this.sliderGallery();
    this.textareaResize();
    this.inViewport();
  }

  anchor() {
    const anchorLinks = document.querySelectorAll(
      'a[href^="#"]:not([href="#"])'
    );

    if (anchorLinks) {
      const header = document.querySelector(".main-header");
      const logo = document.querySelector(".main-logo");

      const offsetY =
        (logo ? logo.offsetHeight : 0) +
        (header
          ? Number.parseFloat(window.getComputedStyle(header).marginTop) * 2
          : 0);

      anchorLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault(); // Empêche le comportement par défaut

          // Récupère l'ID de la section ciblée
          const targetId = link.getAttribute("href");
          if (targetId === "#") return; // Ignore les liens avec un "#" seul

          const targetSection = document.querySelector(targetId);
          if (!targetSection) return; // Ignore si la cible n'existe pas

          // Utilise GSAP pour scroller vers la section
          gsap.to(window, {
            duration: 1, // Durée de l'animation
            scrollTo: {
              y: targetSection, // Section cible
              offsetY : 30, // Décalage facultatif
            },
            ease: "expo.out", // Courbe d'animation
          });
        });
      });
    }
  }


  async contact() {
    const forms = document.querySelectorAll(".form-contact");

    if (forms) {
      forms.forEach((form) => {

        form.addEventListener("submit", async (e) => {
          e.preventDefault();
          const oldMsg = form.querySelectorAll(".form-msg");
          if (oldMsg) {
            oldMsg.forEach((m) => m.remove());
          }

          form.classList.add("loading");

          const formData = new FormData(form);
          formData.append("timestamp", Date.now());

          const url = "https://www.delta-festival.com/api/contact";
          try {
            const response = await fetch(url, {
              method: "POST",
              headers: {
                "content-type": "application/json",
              },
              // body: JSON.stringify(Object.fromEntries(formData.entries())),
              body: JSON.stringify({
                subject: e.target.subject.value,
                firstname: e.target.firstname.value,
                lastname: e.target.lastname.value,
                email: e.target.email.value,
                message: e.target.msg.value,
                timestamp: Date.now(),
              }),
            });
            const output = await response.json();
            form.classList.remove("loading");

            let m = msg.form_error;
            if (output && output.success) {
              form.reset();
              m = msg.form_success;
            } else {
              console.error(output);
            }

            const msgEl = document.createElement("div");
            msgEl.innerHTML = m;
            msgEl.classList.add("form-msg");

            form.querySelector('.box-msg').prepend(msgEl);
          } catch (e) {
            console.error(e);
            form.classList.remove("loaded");

            const msgEl = document.createElement("div");
            msgEl.classList.add("form-msg");
            msgEl.innerHTML = msg.form_error;
            form.prepend(msgEl);
          }

          return false;
        });
      });
    }
  }

  cloud() {
    const clouds = document.querySelectorAll("[data-cloud]");

    if (clouds) {
      clouds.forEach((cloud) => {
        const bound = cloud.getBoundingClientRect();
        const wW = window.innerWidth;
        const tl = gsap.timeline({ paused: true, repeat: -1 });
        const { x, width } = bound;
        const duration = 20 * cloud.dataset.cloud;

        if (cloud.dataset.cloud > 0) {
          const distance1 = wW - x;
          const distance2 = -x - width;
          const total = Math.abs(distance1) + Math.abs(distance2);

          tl.to(cloud, {
            duration: Math.abs((distance1 / total) * duration),
            x: distance1,
            ease: "none",
          })
            .set(cloud, { x: distance2 })
            .to(cloud, {
              duration: Math.abs((distance2 / total) * duration),
              x: 0,
              ease: "none",
            });
        } else {
          const distance1 = wW - x;
          const distance2 = -x - width;
          const total = Math.abs(distance1) + Math.abs(distance2);

          tl.to(cloud, {
            duration: Math.abs((distance2 / total) * duration),
            x: distance2,
            ease: "none",
          })
            .set(cloud, { x: distance1 })
            .to(cloud, {
              duration: Math.abs((distance1 / total) * duration),
              x: 0,
              ease: "none",
            });
        }

        cloud.addEventListener("inview", () => {
          tl.play();
        });
        cloud.addEventListener("outview", () => {
          tl.pause();
        });
      });
    }
  }

  parallax() {
    const elts = document.querySelectorAll("[data-parallax]");

    if (elts) {
      elts.forEach((el) => {
        const layers = el.querySelectorAll("[data-parallax-layer]"); // Trouver la couche parallax

        if (layers) {
          layers.forEach((layer) => {
            const speed = layer.dataset.parallaxLayer || 20; // Récupérer la vitesse depuis l'attribut data-speed
            gsap.to(layer, {
              yPercent: -speed, // Appliquer la vitesse personnalisée
              ease: "none",
              scrollTrigger: {
                trigger: el,
                start: "top top", // Début de l'animation
                end: "bottom top", // Fin de l'animation
                scrub: true, // Synchronisé avec le défilement
              },
            });
          });
        }
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts) {
      elts.forEach((el) => {
        const items = el.querySelectorAll(".accordion-item");
        const headers = el.querySelectorAll(".accordion-header");
        const contents = el.querySelectorAll(".accordion-content");

        if (items && headers && contents) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();

              if (contents[i]) {
                gsap.to(contents[i], {
                  autoAlpha: items[i].classList.contains("open") ? 0 : 1,
                  height: items[i].classList.contains("open")
                    ? 0
                    : contents[i].children[0].offsetHeight,
                  duration: 0.4,
                  ease: "circ.inOut",
                });

                items[i].classList.toggle("open");
              }
            });
          });
        }
      });
    }
  }

  coverVideo() {
    const elts = document.querySelectorAll(".cover-video");

    if (elts) {
      elts.forEach((el) => {
        const sticky = el.querySelector(".content-sticky");
        if (sticky) {
          const tl = gsap.timeline({
            scrollTrigger: {
              trigger: el,
              pin: sticky,
              start: "top top",
              end: "+=100%",
              scrub: 1,
              // markers: true,
            },
          });
          const mask = el.querySelector(".mask");
          const maskVideo = el.querySelector(".mask-video");
          const wysiwyg = el.querySelector(".wysiwyg");


        // VanillaTilt.init(document.querySelector('[data-tilt]'), {
        //   perspective : 10,
        //   max: 5
        // })

          tl.to(
            mask,
            {
              clipPath:
                "polygon(0% 0, 100% 0, 100% calc(100% - 0rem), 0% 100%)",
              width: "100vw",
              height: "100vh",
              marginLeft: "0px",
              duration: 1,
            },
            "start"
          )
            .to(
              maskVideo,
              {
                clipPath:
                  "polygon(0% 0, 100% 0, 100% calc(100% - 0rem), 0% 100%)",
                scale: 1,
                x: 0,
                y: 0,
                duration: 1,
              },
              "start"
            )
            .to(
              wysiwyg,
              {
                autoAlpha: 0,
                duration: 0.2,
                y: "-80%",
              },
              "start"
            );
        }
      });
    }
  }

  bodymovin() {
    const tags = document.querySelectorAll("[data-bodymovin]");

    if (tags) {
      tags.forEach((tag) => {
        tag.addEventListener("inview", () => {
          if (!tag.classList.contains("loaded")) {
            const anim = tag.dataset.bodymovin;
            // const path = `${WPTEMPLATE}/static/bodymovin/${anim}/data.json`;
            fetch(anim).then((response) => {
              if (response.status == 200) {
                const l = lottie.loadAnimation({
                  container: tag,
                  renderer: "svg",
                  loop: true,
                  autoplay: tag.dataset.bodymovinAutoplay && tag.dataset.bodymovinAutoplay != '0' ? false : true,
                  path: anim,
                  rendererSettings: {
                    preserveAspectRatio: 'xMidYMid slice'
                  }
                });
                l.addEventListener('DOMLoaded', () => {
                  tag.classList.add("loaded");

                  // const svg = tag.querySelector('svg');
                  // window.addEventListener('resize', () => {
                  //   const width = ( tag.offsetWidth > tag.offsetHeight) ? '100%' : 'auto';
                  //   const height = ( tag.offsetWidth > tag.offsetHeight) ? 'auto' : '100%';

                  //   gsap.set(svg, {
                  //     width,
                  //     height,
                  //     top: '50%',
                  //     left: '50%',
                  //     x: '-50%',
                  //     y: '-50%'
                  //   })
                  // })

                  // window.dispatchEvent(new Event('resize'));
                })
                tag.lottie = l;

                if( tag.dataset.bodymovinAutoplay && tag.dataset.bodymovinAutoplay != '' ) {
                  setTimeout(() => {
                    l.play();
                    tag.classList.add("loaded");
                  }, parseFloat(tag.dataset.bodymovinAutoplay) * 1000)
                } else {
                }
              }
            });
          } else if (tag.lottie) {
            tag.lottie.play();
          }
        });

        tag.addEventListener("outview", () => {
          if (tag.lottie) {
            // tag.lottie.pause();
          }
        });
      });
    }
  }

  sliderGallery() {
    const elts = document.querySelectorAll(".slider-gallery");

    if (elts) {
      elts.forEach((el) => {
        const flky = new Flickity(el, {
          cellAlign: "center",
          pageDots: false,
          prevNextButtons: true,
          wrapAround: true,
        });
      });
    }
  }

  artistList() {
    const elts = document.querySelectorAll(".artist-list");

    if (elts) {
      elts.forEach((el) => {
        const iso = new Isotope(el, {
          itemSelector: ".item",
          layoutMode: "masonry",
        });
      });
    }
  }

  textareaResize() {
    /**
     * Textarea
     */
    // expand height textarea
    function autoExpand(field) {
      // Reset field height
      field.style.height = "inherit";

      // Get the computed styles for the element
      const computed = window.getComputedStyle(field);

      // Calculate the height
      const height =
        Number.parseInt(computed.getPropertyValue("border-top-width"), 10) +
        // parseInt(computed.getPropertyValue('padding-top'), 10) +
        field.scrollHeight +
        // parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        Number.parseInt(computed.getPropertyValue("border-bottom-width"), 10);

      field.style.height = `${height}px`;
    }

    document.addEventListener("input", (event) => {
      if (event.target.tagName.toLowerCase() !== "textarea") return;
      autoExpand(event.target);
    });
  }

  isTouchDevice() {
    return (
        'ontouchstart' in window || // Détection des événements tactiles
        navigator.maxTouchPoints > 0 || // Points de contact
        window.matchMedia("(pointer: coarse)").matches // Médias CSS
    );
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
